import React from 'react';
import BaseComponent from '../../../../../baseClasses/BaseComponent';
import TaskCompletionStepComments from '../TaskCompletionStepComments';

import './CommentPopup.scss';

class CommentPopup extends BaseComponent {
  constructor(props) {
    super(props);
    this.state = { menu: null, top: 0 };
  }

  componentDidMount() {
    this.handleOffScreen();
  }

  handleOffScreen() {
    const rect = this.commentContainer.getBoundingClientRect();
    if (rect.bottom > window.innerHeight) {
      let top = this.props.top - (rect.bottom - window.innerHeight);
      this.setState({ top });
    }
  }

  handleClickBackground(e) {
    if (e.target.id == 'comment-popup-background' || e.target.id == 'cancel-button') {
      if (this.props.cancelComment) {
        this.props.cancelComment();
      }
    }
  }

  render() {
    const { width, left, top, height } = this.props;
    const style = { width: width, left: left, top: this.state.top ? this.state.top : top, height: height };
    return (
      <div 
        className="comment-popup" 
        onClick={this.handleClickBackground} 
        id="comment-popup-background">
        <div 
          className="comment-container" 
          style={style} 
          ref={el => this.commentContainer = el}
          id="comment-container">
          <div 
            className="cancel-button" 
            onClick={this.handleClickBackground} 
            id="cancel-button"
          />
          <TaskCompletionStepComments 
            key={'comment-popup-' + this.props.completionStep.id} 
            fromPopup={true} 
            placeholder={this.props.placeholder}
            task={this.props.task} 
            completionStep={this.props.completionStep} 
            commentSent={this.props.commentSent} type={this.props.type} 
          />
          </div>
      </div>
    );
  }
}

export default CommentPopup;



// WEBPACK FOOTER //
// ./src/components/TaskCRUD/TaskCompletionStepsContainer/TaskCompletionSteps/CommentPopup/index.js